import React from 'react';

const Loader = () => {
  return (
    <div className="loader">
      <div className="loader__page"></div>
      <div className="loader__section loader__left"></div>
      <div className="loader__section loader__right"></div>
    </div>
  );
};

export default Loader;
